import CardClientSa from "assets/images/card_client_sa.png"
import CardSmartCustomer from "assets/images/cart_smart_customer.png"
import CardBestPerformance from "assets/images/card_best_performance.png"
import CardTrackCo from "assets/images/card_track_co.png"
import CardPremioReclameAqui from "assets/images/card_premio_reclame_aqui.png"
import CardClientSaCx from "assets/images/card_client_sa_cx.png"
import CardSeguradorBrasil from "assets/images/card_segurador_brasil.png"
import CardOuvidoriaBrasil from "assets/images/card_ouvidoria_brasil.png"
import CardXxivPremioAbt from "assets/images/card_xxiv_premio_abt.png"

import CardClientSaFallback from "assets/images/card_client_sa.webp"
import CardSmartCustomerFallback from "assets/images/cart_smart_customer.webp"
import CardBestPerformanceFallback from "assets/images/card_best_performance.webp"
import CardTrackCoFallback from "assets/images/card_track_co.webp"
import CardPremioReclameAquiFallback from "assets/images/card_premio_reclame_aqui.webp"
import CardClientSaCxFallback from "assets/images/card_client_sa_cx.webp"
import CardSeguradorBrasilFallback from "assets/images/card_segurador_brasil.webp"
import CardOuvidoriaBrasilFallback from "assets/images/card_ouvidoria_brasil.webp"
import CardXxivPremioAbtFallback from "assets/images/card_xxiv_premio_abt.webp"


export const AchievementsOurCards = [
    {
        image: CardClientSa,
        imageFallback: CardClientSaFallback,
        title: "ClienteSA",
        paragraph: "Troféu ouro na categoria ”Líder em Projeto de Cultura Cliente”.",
        Backgroundcolor: "#D70064"
    },
    {
        image: CardSmartCustomer,
        imageFallback: CardSmartCustomerFallback,
        title: "Smart Customer 2024",
        paragraph: "Troféu ouro na categoria ”Cultura organizacional”.",
        Backgroundcolor: "#008C84"
        
    },
    {
        image: CardBestPerformance,
        imageFallback: CardBestPerformanceFallback,
        title: "Best Performance",
        paragraph: "Troféu prata na categoria ”Excelência na Gestão de Seguros”.",
        Backgroundcolor: "#002364"
    },
    {
        image: CardTrackCo,
        imageFallback: CardTrackCoFallback,
        title: "Track.co",
        paragraph: "Troféu prata na categoria ”Cultura” pelo case ”Conexão CX”.",
        Backgroundcolor: "#D70064"
    },
    {
        image: CardPremioReclameAqui,
        imageFallback: CardPremioReclameAquiFallback,
        title: "Prêmio Reclame Aqui",
        paragraph: "Segundo lugar na categoria ”Seguros em Geral - Grandes Operações”.",
        Backgroundcolor: "#008C84"
    },
    {
        image: CardClientSaCx,
        imageFallback: CardClientSaCxFallback,
        title: "ClienteSA CX",
        paragraph: "Vencedora na categoria ”Maturidade em Experiência do Cliente”.",
        Backgroundcolor: "#002364"
    },
    {
        image: CardSeguradorBrasil,
        imageFallback: CardSeguradorBrasilFallback,
        title: "Segurador Brasil",
        paragraph: "Vencedora na categoria ”Líder em Seguro Habitacional”.",
        Backgroundcolor: "#008C84"
    },
    {
        image: CardOuvidoriaBrasil,
        imageFallback: CardOuvidoriaBrasilFallback,
        title: "Ouvidorias Brasil",
        paragraph: "Troféu ouro pelo case de sucesso ”Projeto Promotor”.",
        Backgroundcolor: "#002364"
    },
    {
        image: CardXxivPremioAbt,
        imageFallback: CardXxivPremioAbtFallback,
        title: "XXIV Prêmio ABT",
        paragraph: "Troféu prata na categoria ”Jornada do Cliente”.",
        Backgroundcolor: "#D70064"
    },
]